export default "__VITE_ASSET__DngfFACP__"